import { Box, SxProps, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import {
  hand,
  upload,
  rotateCCW,
  plus,
  minus,
  photo,
  scissorsCutLine,
  eyeBroken,
  arrowLeftOutline,
  arrowRightOutline,
  uploadFilled,
} from './icons';

export type IconName =
  | 'hand'
  | 'upload'
  | 'rotateCCW'
  | 'plus'
  | 'minus'
  | 'photo'
  | 'scissorsCutLine'
  | 'eyeBroken'
  | 'arrowLeftOutline'
  | 'arrowRightOutline'
  | 'uploadFilled'
  | string

const icons: Record<IconName, ReactNode> = {
  hand,
  upload,
  rotateCCW,
  plus,
  minus,
  photo,
  scissorsCutLine,
  eyeBroken,
  arrowLeftOutline,
  arrowRightOutline,
  uploadFilled
};

type CustomIconProps = {
  name: IconName;
  styles?: SxProps<Theme>;
  className?: string;
  onClick?: () => void;
};

export const CustomIcon: FC<CustomIconProps> = ({ name, styles, className, onClick }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        alignItems: 'center',
        ...styles,
      }}
      className={className}
      onClick={onClick}
    >
      {icons[name]}
    </Box>
  );
};
